import { render, staticRenderFns } from "./Page-Consultation.vue?vue&type=template&id=ec2b5b80"
import script from "./Page-Consultation.vue?vue&type=script&lang=js"
export * from "./Page-Consultation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports